import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackEnteredFullScreen, useTrackExitedFullScreen } from "@air/analytics";
import { SegmentedControl } from "@air/component-segmented-control";
import { memo } from "react";
import { useAnnotationsToggle } from "~/components/AnnotationsV2/hooks/useAnnotationsToggle";
import { SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS } from "~/components/AssetModalV2/constants";
import { useVideoContentControlsContext } from "~/components/AssetModalV2/Content/VideoContentControlsContextProvider";
import { useFullscreenContext } from "~/components/AssetModalV2/shared/context/FullscreenContext";
export const ModeToggleSegmentedControl = /*#__PURE__*/ memo(()=>{
    const { showAnnotations, hideAnnotations } = useAnnotationsToggle();
    const { isFullscreen, toggleFullscreen } = useFullscreenContext();
    const { pause } = useVideoContentControlsContext();
    const { trackEnteredFullScreen } = useTrackEnteredFullScreen();
    const { trackExitedFullScreen } = useTrackExitedFullScreen();
    const handleCommentModeToggle = (option)=>{
        if (option.value === "fullscreen") {
            // Full screen mode: hide annotations and enable fullscreen
            hideAnnotations();
            if (!isFullscreen) {
                toggleFullscreen();
                trackEnteredFullScreen({
                    location: "video"
                });
            }
        } else {
            // Comment mode: show annotations and exit fullscreen
            showAnnotations();
            if (isFullscreen) {
                toggleFullscreen();
                trackExitedFullScreen({
                    location: "video"
                });
            }
            // Pause video when entering annotation mode
            pause();
        }
    };
    const selectedOption = isFullscreen ? SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS[0] // fullscreen
     : SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS[1]; // comment-mode
    const activeColor = isFullscreen ? "orange" : "purple";
    return /*#__PURE__*/ _jsx(SegmentedControl, {
        options: SEGMENTED_CONTROL_FULL_SCREEN_COMMENT_MODE_OPTIONS,
        selectedOption: selectedOption,
        onSelect: handleCommentModeToggle,
        activeColor: activeColor
    });
});
ModeToggleSegmentedControl.displayName = "ModeToggleSegmentedControl";
